import { get } from "./utils";

export async function getPaymentMethodApi() {
    return get(`/payment-method`);
}